export default __webpack_public_path__ + "static/media/wok.754a82ed.jpg";